export const client_id = 'a01ac38bd9514c2eb5cf5e9acb2c9fa1', client_secret = 'ab22cec87e72492e9a2b5e5fdc0071d4';